import { useMemo } from "react";

// coler scheme
export const getColorScheme = (mode) => {
  const colorSchemes = {
    light: {
      mode: "light",
      background: "#0A0A0A",
      backgroundSecondary: "#121715",
      white: "#fff",
      textPrimary: "#ffffff",
      textSecondary: "#b3b3b3",
      graytext: "#727272",
      graytexttwo: "#adadadd8",
      black: "#000",
      ActiveLink: "#008477",
      buttonbg: "#008477",
      buttonbgtwo: "#3D4643",
      disbuttonbg: "#121715",
      border: "#2a2a2a",
      buttonBorder: "#008477",
      inputBackground: "#2a2a2a",
      tableBg: "#0A0A0A",
      card: "#282828",
    },
    dark: {
      mode: "dark",
      background: "#0A0A0A",
      backgroundSecondary: "#121715",
      white: "#fff",
      textPrimary: "#ffffff",
      textSecondary: "#b3b3b3",
      graytext: "#727272",
      graytexttwo: "#adadadd8",
      black: "#000",
      ActiveLink: "#008477",
      buttonbg: "#008477",
      buttonbgtwo: "#3D4643",
      disbuttonbg: "#121715",
      border: "#2a2a2a",
      buttonBorder: "#008477",
      inputBackground: "#2a2a2a",
      tableBg: "#0A0A0A",
      card: "#282828",
      headerBg:"#008477",
      ActiveLinkheader:"#21205E"
    },
  };

  return colorSchemes[mode] || colorSchemes.light;
};

const useThemeHook = () => {
  const mode = "dark";
  const theme = useMemo(() => getColorScheme(mode), [mode]);

  return { theme };
};

export default useThemeHook;
